"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseERC20Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var BaseERC20Factory = /** @class */ (function (_super) {
    __extends(BaseERC20Factory, _super);
    function BaseERC20Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    BaseERC20Factory.prototype.deploy = function (name_, symbol_, decimals_, overrides) {
        return _super.prototype.deploy.call(this, name_, symbol_, decimals_, overrides || {});
    };
    BaseERC20Factory.prototype.getDeployTransaction = function (name_, symbol_, decimals_, overrides) {
        return _super.prototype.getDeployTransaction.call(this, name_, symbol_, decimals_, overrides || {});
    };
    BaseERC20Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BaseERC20Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BaseERC20Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return BaseERC20Factory;
}(contracts_1.ContractFactory));
exports.BaseERC20Factory = BaseERC20Factory;
var _abi = [
    {
        inputs: [
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "decimals_",
                type: "uint8",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        inputs: [],
        name: "DOMAIN_SEPARATOR",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "PERMIT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "nonces",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "deadline",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "permit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "address",
                name: "recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
